// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.timeout-input[data-v-4d84291a] {\n  width: 100px;\n}\n.scroll-input[data-v-4d84291a] {\n  width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
